module.exports = __webpack_public_path__ + "img/icon-star-badge.19e56ed1.svg";